import styled from "@emotion/styled";
import { APIScope } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import React from "react";

import { ShowIf } from "../../../../../Components/ShowIf/ShowIf";
import { QuestModelHelper } from "../../../../../Models/Quests/Helpers/QuestModel.Helper";
import { QuestsModel } from "../../../../../Models/Quests/Quests.Model";

interface WrapperProps {
  isAdding: boolean;
}
const Wrapper = styled.div<WrapperProps>`
  position: relative;
  padding: 12px 12px 12px 0;
  transition: all 0.3s ease;

  width: 10px;

  &.isAdding,
  &:hover {
    width: 288px;

    .addButton {
      opacity: 1;
    }
  }

  cursor: pointer;
`;

// const AddQuest = styled.div`
//     background-color: #F0ECE9;
//     flex:1;
//     border: 2px dashed #C3BCB9;
//     border-radius: 8px;
//     margin-right: 12px;
//     height:45px;
//     cursor: pointer;
//     `;

const AddButton = styled.div`
  transition: all 0.2s ease;

  opacity: 0;
  top: 20px;
  right: 10px;
  position: absolute;
  min-height: 80vh;
  width: 258px;

  font-size: 14px;
  background-color: #f0ece9;
  flex: 1;
  border: 2px dashed #c3bcb9;
  height: 45px;
  border-radius: 8px;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #413b38;

  &:hover {
    background-color: #fdf6f3;
  }
  $:active {
    color: #5e5450;
    border-color: #5e5450;
  }
`;

export default function AddQuestButtons() {
  const [isAdding, setIsAdding] = React.useState(false);
  const addJourneyClicked = async () => {
    if (isAdding) {
      return;
    }
    setIsAdding(true);
    const journey = QuestModelHelper.newJourney("New Journey");
    await QuestsModel.createJourney(journey);
    setIsAdding(false);
  };
  return (
    <ShowIf scope={APIScope.WORKFLOWS_EDIT}>
      <Wrapper className={isAdding ? "AddQuestButtons isAdding" : "AddQuestButtons"} isAdding={isAdding}>
        <AddButton className="addButton" onClick={addJourneyClicked}>
          {isAdding ? <Spinner /> : "+ New Journey"}
        </AddButton>
      </Wrapper>
    </ShowIf>
  );
}
